import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { useParams } from 'react-router-dom';
import Editor from '@monaco-editor/react';
import axiosInstance from 'api/axiosInstance';
import apiUrls from 'api/apiUrls';
import JSZip from 'jszip';
import InterfaceSelect from 'components/select';
import {
  Box,
  Flex,
  Button,
  // Text,
  // useDisclosure,
  // Select,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  useColorModeValue,
  useColorMode,
  useToast,
  Text,
  Heading,
  useDisclosure,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
// import { useNavigate } from 'react-router-dom';
import { Skeleton, SkeletonText } from '@chakra-ui/react';
// import { useLocation } from 'react-router-dom';
import GlobalAlertDialog from 'components/GlobalAlertDialog';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Checkbox, SimpleGrid } from '@chakra-ui/react';
import GlobalModal from 'components/GlobalModal';
import { InputGroup, InputLeftElement } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import Default from 'components/fields/InputField';
import FileExplorer from '../logic/FileExplorer';
import Sidebar from 'components/sidebar/Sidebar';
import ClusterModal from 'components/ClusterModal';
import { sortDevices } from 'views/hooks/sortDevices';
import Cookies from 'js-cookie';
import BreadCrumb from 'components/breadCrumb/BreadCrumb';
const PLATFORM_ID = process.env.REACT_APP_PLATFORM_ID;

const NameModal = ({
  isOpen,
  onClose,
  title,
  placeholder,
  value,
  onChange,
  onConfirm,
  confirmLabel = 'Confirm',
  isConfirmDisabled = false,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent bg={useColorModeValue('white', 'navy.700')}>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Input
            color={useColorModeValue('navy.700', 'white')}
            placeholder={placeholder}
            autoFocus
            value={value}
            onChange={onChange}
          />
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            onClick={onConfirm}
            isDisabled={isConfirmDisabled}
          >
            {confirmLabel}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const PatchConfigurations = () => {
  const userAuthority = localStorage.getItem('userAuthority');
  const customerId = localStorage.getItem('customerId');
  const isTenantAdmin = userAuthority === 'TENANT_ADMIN';
  const groupId = localStorage.getItem('groupID');
  const toast = useToast();
  const { colorMode } = useColorMode();
  // const navigate = useNavigate();
  // const { deviceUUID } = useParams();
  const location = useLocation();
  const deviceId = localStorage.getItem('deviceId');

  const [patchNameModalOpen, setPatchNameModalOpen] = useState(false);

  const [pythonCode, setPythonCode] = useState('');
  const [files, setFiles] = useState([]);

  const [selectedFile, setSelectedFile] = useState(null);
  const [editorTheme, setEditorTheme] = useState(
    useColorModeValue('vs-light', 'vs-dark'),
  );

  useEffect(() => {
    const newTheme = colorMode === 'dark' ? 'vs-dark' : 'vs-light';
    setEditorTheme(newTheme);
  }, [colorMode]);

  // Wrap generateId in useCallback to stabilize its reference
  const generateId = useCallback(
    () => `id_${Math.random().toString(36).substr(2, 9)}`,
    [],
  );
  const [loading, setLoading] = useState(true);
  const [patchName, setPatchName] = useState('');
  const breadcrumbItems = [
    { label: 'Home', path: '/dashboard' },
    { label: 'All Patches', path: '/patches' },
    { label: patchName, path: null },
  ];
  const [patchConfigMap, setPatchConfigMap] = useState({});
  const [patchOptions, setPatchOptions] = useState([]); // <-- change from patchConfigMap
  const [patchId, setPatchId] = useState(null);
  const [patchVersion, setPatchVersion] = useState(0);
  const navigate = useNavigate();
  const textColor = useColorModeValue('navy.700', 'white');
  const inputBg = useColorModeValue('white', 'navy.600');

  const panelBg = useColorModeValue('white', 'navy.700');
  const optionText = useColorModeValue('navy.800', 'white');

  // Rename Modal state
  const [renameState, setRenameState] = useState({
    isOpen: false,
    item: null,
    newName: '',
  });
  // Delete confirmation state
  const [deleteState, setDeleteState] = useState({ isOpen: false, item: null });
  // Create file modal state
  const [createFileState, setCreateFileState] = useState({
    isOpen: false,
    parent: null,
    fileName: '',
  });
  // Create folder modal state
  const [createFolderState, setCreateFolderState] = useState({
    isOpen: false,
    parent: null,
    folderName: '',
  });
  const [isSaveLogicModalOpen, setIsSaveLogicModalOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved ? JSON.parse(saved) : false;
  });
  const sidebarExpandedWidth = '260px';
  const sidebarCollapsedWidth = '80px';
  const sidebarWidth = collapsed ? sidebarCollapsedWidth : sidebarExpandedWidth;
  const [currentPage, setCurrentPage] = useState(0);
  const [isApplyConfirmOpen, setIsApplyConfirmOpen] = useState(false);
  const { id: urlPatchid } = useParams();
  const devices = location.state?.devices || [];
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [serialNumber, setSerialNumber] = useState('');
  const [searchType, setSearchType] = useState('deviceId');
  const [clusterOptions, setClusterOptions] = useState([]);
  const [selectedCluster, setSelectedCluster] = useState('');
  const [stateOptions, setStateOptions] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const [nocOptions, setNocOptions] = useState([]);
  const [selectedNoc, setSelectedNoc] = useState('');
  const [plantOptions, setPlantOptions] = useState([]);
  const [selectedPlant, setSelectedPlant] = useState('');
  const [configDeviceMap, setConfigDeviceMap] = useState({});
  const [hasNext, setHasNext] = useState(false);
  const [loadingDevices, setLoadingDevices] = useState(false);
  const isFirstRender = useRef(true);
  const [devicesArray, setDevicesArray] = useState([]);
  const [preselectedDeviceIds, setPreselectedDeviceIds] = useState([]);
  const [preselectedDevices, setPreselectedDevices] = useState([]);
  const status = location.state?.status;
  const isActive = location.state?.isActive || false;

  const {
    isOpen: isOpenSaveConf,
    onOpen: DeviceSaveConf,
    onClose: onCloseSaveConf,
  } = useDisclosure();

  const fetchAllDevices = useCallback(
    async (serialNumber = '', setLoading = true, page = 0) => {
      setLoadingDevices(setLoading);

      let apiUrl = apiUrls.allDevices(serialNumber, page);

      const resp = await axiosInstance.get(apiUrl);

      const devices = resp.data.data;
      setHasNext(resp.data.hasNext);

      const devicesNameIdMap = sortDevices(devices.map((d) => d.name)).map(
        (name) => ({
          id: name,
          name,
        }),
      );

      if (serialNumber || page === 0) {
        setDevicesArray(devicesNameIdMap);
      } else {
        const newDevices = devicesNameIdMap.filter((d) => {
          if (deviceId !== d.id) {
            return !selectedDevices.includes(d.id);
          } else {
            return true;
          }
        });
        setDevicesArray((prev) => [...prev, ...newDevices]);
      }

      setLoadingDevices(false);
    },
    [deviceId],
  );

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (serialNumber) {
      setCurrentPage(0);
    }

    if (currentPage === -1) return;

    if (searchType === 'deviceId') {
      fetchAllDevices(serialNumber, true, currentPage);
    }
  }, [currentPage, serialNumber, fetchAllDevices, searchType]);
  useEffect(() => {
    localStorage.setItem('sidebarCollapsed', JSON.stringify(collapsed));
  }, [collapsed]);
  const handleSaveLogicToDevices = async () => {
    if (!patchName.trim()) return;
    const hasMain = files.some(
      (f) => f.type === 'file' && f.name === 'main.py',
    );
    const hasRequirements = files.some(
      (f) => f.type === 'file' && f.name === 'requirements.txt',
    );
    const versionFile = files.find(
      (f) => f.type === 'file' && f.name === 'version.txt',
    );
    if (!hasMain || !hasRequirements) {
      toast({
        title: 'Missing Required Files',
        description:
          "Make sure 'main.py' and 'requirements.txt' exist before uploading.",
        status: 'warning',
        position: 'top',
        duration: 4000,
        isClosable: true,
      });
      return;
    }
    if (!versionFile || !versionFile.content || !versionFile.content.trim()) {
      toast({
        title: 'Missing Version',
        description: "The 'version.txt' file must not be empty.",
        status: 'error',
        position: 'top',
        duration: 4000,
        isClosable: true,
      });
      return;
    }
    if (!/^v\d+$/i.test(versionFile.content.trim())) {
      toast({
        title: 'Invalid Version Format',
        description:
          "The 'version.txt' file must be in the format 'v1', 'v2', etc.",
        status: 'error',
        position: 'top',
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    const versionMatch = patchName.match(/v?(\d+)/i);
    const patchVersion = versionMatch ? parseInt(versionMatch[1], 10) : 1;

    const zip = new JSZip();
    const buildZipTree = (currentFolder, parent) => {
      const children = files.filter(
        (f) => f.parentId === (parent ? parent.id : null),
      );
      for (const item of children) {
        if (item.type === 'file') {
          currentFolder.file(item.name, item.content || '');
        } else if (item.type === 'folder') {
          const newFolder = currentFolder.folder(item.name);
          buildZipTree(newFolder, item);
        }
      }
    };
    buildZipTree(zip, null);
    try {
      const blob = await zip.generateAsync({ type: 'blob' });
      const arrayBuffer = await blob.arrayBuffer();
      const base64Data = btoa(
        new Uint8Array(arrayBuffer).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          '',
        ),
      );

      const payload = {
        apply_to_devices: 0,
        content: base64Data,
        version: patchVersion,
        patch_id: patchId,
        patch_name: patchName,
      };
      await axiosInstance.post(
        apiUrls.updatePatch(PLATFORM_ID, groupId),
        payload,
      );

      toast({
        title: 'Upload Successful',
        description: 'Files zipped and uploaded successfully.',
        status: 'success',
        position: 'top',
        duration: 3000,
        isClosable: true,
      });
      setIsSaveLogicModalOpen(false);
      // await fetchPatches(); // <-- Remove this line
      await fetchConfigurations();
    } catch (err) {
      const errorMsg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.response?.data ||
        err?.message ||
        'An error occurred while uploading the zip.';

      toast({
        title: 'Upload Failed',
        description: errorMsg,
        status: 'error',
        position: 'top',
        duration: 4000,
        isClosable: true,
      });
      return false;
    }
  };

  // useEffect(() => {
  //   console.log(editorTheme)
  // }, [editorTheme]);

  // const handleUploadClick = () => {
  //   setPatchNameModalOpen(true);
  // };

  // Wrap initializeDefault in useCallback
  const initializeDefault = useCallback(() => {
    const projectFolderId = generateId();
    const mainFileId = generateId();
    const reqFileId = generateId();
    const versionFileId = generateId();

    const struct = [
      {
        id: projectFolderId,
        name: 'Project',
        type: 'folder',
        parentId: null,
      },
      {
        id: mainFileId,
        name: 'main.py',
        type: 'file',
        content: '# main\n',
        parentId: projectFolderId,
      },
      {
        id: reqFileId,
        name: 'requirements.txt',
        type: 'file',
        content: '',
        parentId: projectFolderId,
      },
      {
        id: versionFileId,
        name: 'version.txt',
        type: 'file',
        content: 'v1',
        parentId: projectFolderId,
      },
    ];

    setFiles(struct);
    setSelectedFile(struct[1]);
    setPythonCode(struct[1].content);

    return struct;
  }, [generateId, setFiles, setSelectedFile, setPythonCode]);

  // Move fillData function inside Logic component and wrap in useCallback
  // Move fillData above fetchPatchDetails and fetchConfigurations
  const fillData = useCallback(
    async (resp) => {
      const patchValue = resp.data?.find(({ key }) => key === 'patch')?.value;
      setPatchName(
        resp.data?.find(({ key }) => key === 'patch_name')?.value || '',
      );
      setPatchId(
        resp.data?.find(({ key }) => key === 'patch_id')?.value || null,
      );
      setPatchVersion(
        parseInt(
          resp.data?.find(({ key }) => key === 'patch_v')?.value || '0',
          10,
        ),
      );

      if (!patchValue) {
        const defaultStruct = initializeDefault();
        setFiles(defaultStruct);
        return;
      }

      let explorer;

      try {
        explorer = JSON.parse(patchValue);
      } catch (jsonErr) {
        // console.log('Not valid JSON, assuming base64 zip...');

        const zipData = patchValue;
        const zip = new JSZip();

        const binaryStr = atob(zipData); // base64 → binary string
        const byteArray = Uint8Array.from(binaryStr, (c) => c.charCodeAt(0));
        const unzipped = await zip.loadAsync(byteArray);

        const filesList = [];
        const folderMap = {};
        let rootFolderId = null;

        if (!unzipped.folder('Project/')) {
          rootFolderId = generateId();
          folderMap['Project'] = rootFolderId;
          filesList.push({
            id: rootFolderId,
            name: 'Project',
            type: 'folder',
            parentId: null,
          });
        }

        await Promise.all(
          Object.keys(unzipped.files).map(async (filePath) => {
            const zipEntry = unzipped.files[filePath];
            const segments = filePath.split('/').filter(Boolean);
            if (segments.length === 0) return;

            let currentPath = 'Project';
            let parentId = rootFolderId;

            for (let i = 0; i < segments.length - (zipEntry.dir ? 0 : 1); i++) {
              currentPath += `/${segments[i]}`;
              if (!folderMap[currentPath]) {
                const id = generateId();
                folderMap[currentPath] = id;
                filesList.push({
                  id,
                  name: segments[i],
                  type: 'folder',
                  parentId,
                });
              }
              parentId = folderMap[currentPath];
            }

            if (!zipEntry.dir) {
              const fileName = segments[segments.length - 1];
              const content = await zipEntry.async('text');
              filesList.push({
                id: generateId(),
                name: fileName,
                type: 'file',
                content,
                parentId,
              });
            }
          }),
        );

        const hasRootFolder = filesList.some(
          (f) => f.parentId === null && f.type === 'folder',
        );
        if (!hasRootFolder) {
          const projectId = generateId();
          filesList.forEach((f) => {
            if (f.parentId === null) f.parentId = projectId;
          });

          filesList.unshift({
            id: projectId,
            name: 'Project',
            type: 'folder',
            parentId: null,
          });
        }

        explorer = filesList;
      }

      if (explorer && explorer.length) {
        // Ensure version.txt exists and has content
        let versionFile = explorer.find(
          (f) => f.type === 'file' && f.name === 'version.txt',
        );
        if (!versionFile) {
          // Add version.txt if missing
          const projectFolder = explorer.find(
            (f) => f.type === 'folder' && f.parentId === null,
          );
          explorer.push({
            id: generateId(),
            name: 'version.txt',
            type: 'file',
            content: 'v1',
            parentId: projectFolder ? projectFolder.id : null,
          });
        } else if (!versionFile.content || !versionFile.content.trim()) {
          // Set content to 'v1' if empty
          versionFile.content = 'v1';
        }

        setFiles(explorer);
        setSelectedFile(explorer[1]);
        setPythonCode(explorer[1].content);
      } else {
        initializeDefault();
      }
    },
    [generateId, initializeDefault],
  );

  const fetchConfigurations = useCallback(async () => {
    try {
      const keys = 'patch,patch_v,patch_name,patch_id';
      const resp = await axiosInstance.get(
        apiUrls.getPatchCodeV1(PLATFORM_ID, groupId, urlPatchid, keys),
      );

      // Ensure resp.data is always an array for .find to work
      const dataArr = Array.isArray(resp.data)
        ? resp.data
        : resp.data && typeof resp.data === 'object'
          ? Object.entries(resp.data).map(([key, value]) => ({ key, value }))
          : [];

      await fillData({ data: dataArr });

      // Set patchOptions to a single patch from the fetched data
      const patchNameVal =
        dataArr.find(({ key }) => key === 'patch_name')?.value || '';
      const patchIdVal =
        dataArr.find(({ key }) => key === 'patch_id')?.value || '';
      setPatchOptions(
        patchIdVal
          ? [{ label: patchNameVal || 'Unnamed', value: patchIdVal }]
          : [],
      );
      setPatchId(patchIdVal);
      setPatchName(patchNameVal);

      // Immediately fetch and display the patch code for this patch id
      if (patchIdVal) {
        try {
          const respCode = await axiosInstance.get(
            apiUrls.getPatchCode(patchIdVal),
          );
          const codeArr = Array.isArray(respCode.data)
            ? respCode.data
            : respCode.data && typeof respCode.data === 'object'
              ? Object.entries(respCode.data).map(([key, value]) => ({
                  key,
                  value,
                }))
              : [];
          const patchObj = codeArr.find((item) => item.key === 'patch');
          const patchBase64 = patchObj?.value;
          if (patchBase64) {
            const explorer = await decodeBase64ZipToFiles(
              patchBase64,
              generateId,
            );
            setFiles(explorer);
            // Pick main.py or first file
            const pick =
              explorer.find((f) => f.type === 'file' && f.name === 'main.py') ||
              explorer.find((f) => f.type === 'file') ||
              null;
            if (pick) {
              setSelectedFile(pick);
              setPythonCode(pick.content);
            } else {
              setSelectedFile(null);
              setPythonCode('');
            }
          }
        } catch (err) {
          console.error('getPatchCode failed:', err);
        }
      }
    } catch (err) {
      console.error('Failed to fetch file explorer:', err);
      initializeDefault();
    } finally {
      setLoading(false);
    }
  }, [deviceId, fillData, initializeDefault, generateId]);

  // Remove this useEffect:
  // useEffect(() => {
  //   if (patchId) {
  //     fetchPatchDetails();
  //   }
  // }, [patchId, fetchPatchDetails]);

  // Handler for patch select change
  const handlePatchSelectChange = async (val) => {
    setPatchId(val);
    // Find the selected patch's name from patchOptions
    const selectedPatch = patchOptions.find((opt) => opt.value === val);
    if (selectedPatch) {
      setPatchName(selectedPatch.label || '');
    }
    if (val) {
      try {
        const resp = await axiosInstance.get(apiUrls.getPatchCode(val));
        // Find the patch base64 value
        const patchObj = Array.isArray(resp.data)
          ? resp.data.find((item) => item.key === 'patch')
          : null;
        const patchBase64 = patchObj?.value;
        if (patchBase64) {
          const explorer = await decodeBase64ZipToFiles(
            patchBase64,
            generateId,
          );
          setFiles(explorer);
          // Pick main.py or first file
          const pick =
            explorer.find((f) => f.type === 'file' && f.name === 'main.py') ||
            explorer.find((f) => f.type === 'file') ||
            null;
          if (pick) {
            setSelectedFile(pick);
            setPythonCode(pick.content);
          } else {
            setSelectedFile(null);
            setPythonCode('');
          }
        }
      } catch (err) {
        console.error('getPatchCode failed:', err);
      }
    }
  };

  // Remove useEffect(() => { fetchPatches(); }, [fetchPatches]);

  // Remove auto-select logic for multiple patches
  // useEffect(() => {
  //   if (patchOptions.length > 0 && !patchId) {
  //     const firstPatchId = patchOptions[0].value;
  //     setPatchId(firstPatchId);
  //     handlePatchSelectChange(firstPatchId);
  //   }
  // }, [patchOptions, patchId]);

  useEffect(() => {
    fetchConfigurations();
  }, [fetchConfigurations]);

  // Rename handlers
  const openRename = (item) =>
    setRenameState({ isOpen: true, item, newName: item.name });
  const closeRename = () =>
    setRenameState({ isOpen: false, item: null, newName: '' });
  const handleRenameConfirm = () => {
    if (renameState.newName.trim()) {
      setFiles((prev) =>
        prev.map((f) =>
          f.id === renameState.item.id
            ? { ...f, name: renameState.newName.trim() }
            : f,
        ),
      );
      if (selectedFile?.id === renameState.item.id) {
        setSelectedFile({
          ...renameState.item,
          name: renameState.newName.trim(),
        });
      }
    }
    closeRename();
  };

  // Delete handlers
  const openDelete = (item) => setDeleteState({ isOpen: true, item });
  const closeDelete = () => setDeleteState({ isOpen: false, item: null });
  const handleDeleteConfirm = () => {
    setFiles((prev) => prev.filter((f) => f.id !== deleteState.item.id));
    if (selectedFile?.id === deleteState.item.id) {
      setSelectedFile(null);
      setPythonCode('');
    }
    closeDelete();
  };

  // Create file handlers
  const openCreateFile = (parent) =>
    setCreateFileState({ isOpen: true, parent, fileName: '' });
  const closeCreateFile = () =>
    setCreateFileState({ isOpen: false, parent: null, fileName: '' });
  const handleCreateFileConfirm = () => {
    const nm = createFileState.fileName.trim();
    if (nm) {
      const id = generateId();
      const f = {
        id,
        name: nm,
        type: 'file',
        content: '',
        parentId: createFileState.parent?.id || null,
      };
      setFiles((prev) => [...prev, f]);
      setSelectedFile(f);
      setPythonCode('');
    }
    closeCreateFile();
  };

  // Create folder handlers
  const openCreateFolder = (parent) =>
    setCreateFolderState({ isOpen: true, parent, folderName: '' });
  const closeCreateFolder = () =>
    setCreateFolderState({ isOpen: false, parent: null, folderName: '' });
  const handleCreateFolderConfirm = () => {
    const nm = createFolderState.folderName.trim();
    if (nm) {
      const id = generateId();
      const f = {
        id,
        name: nm,
        type: 'folder',
        parentId: createFolderState.parent?.id || null,
      };
      setFiles((prev) => [...prev, f]);
    }
    closeCreateFolder();
  };

  const handleImportFile = (file, parentFolder = null) => {
    const reader = new FileReader();
    reader.onload = () => {
      const content = reader.result;
      const id = generateId();
      const newFile = {
        id,
        name: file.name,
        type: 'file',
        content,
        parentId: parentFolder?.id || null,
      };
      setFiles((prev) => [...prev, newFile]);
      setSelectedFile(newFile);
      setPythonCode(content);
    };
    reader.readAsText(file);
  };

  const handleFolderImport = (fileList, parentFolder = null) => {
    const folderMap = {}; // To track created folders and their IDs

    // Get root folder name from the first file
    const firstFile = fileList[0];
    const fullPath = firstFile?.webkitRelativePath || firstFile?.name;
    const baseFolderName = fullPath?.split('/')?.[0];

    // Create the root folder (if not already passed as parentFolder)
    let rootFolderId = parentFolder?.id || null;

    if (!parentFolder && baseFolderName) {
      rootFolderId = generateId();
      const rootFolder = {
        id: rootFolderId,
        name: baseFolderName,
        type: 'folder',
        parentId: null,
      };
      setFiles((prev) => [...prev, rootFolder]);
      folderMap[baseFolderName] = rootFolderId;
    }

    const createFolder = (folderPath) => {
      if (folderMap[folderPath]) return folderMap[folderPath];

      const parts = folderPath.split('/');
      const folderName = parts[parts.length - 1];
      const parentPath = parts.slice(0, -1).join('/');
      const parentId = parentPath ? createFolder(parentPath) : rootFolderId;

      const id = generateId();
      const newFolder = {
        id,
        name: folderName,
        type: 'folder',
        parentId,
      };

      setFiles((prev) => [...prev, newFolder]);
      folderMap[folderPath] = id;
      return id;
    };

    Array.from(fileList).forEach((file) => {
      const relativePath = file.webkitRelativePath || file.name;
      const cleanPath = parentFolder
        ? relativePath
        : relativePath.replace(`${baseFolderName}/`, '');

      const pathParts = cleanPath.split('/');

      const reader = new FileReader();
      reader.onload = () => {
        const content = reader.result;
        const id = generateId();

        let parentId = rootFolderId;

        if (pathParts.length > 1) {
          const folderPath = pathParts.slice(0, -1).join('/');
          parentId = createFolder(folderPath);
        }

        const newFile = {
          id,
          name: file.name,
          type: 'file',
          content,
          parentId,
        };

        setFiles((prev) => [...prev, newFile]);
        setSelectedFile(newFile);
        setPythonCode(content);
      };

      reader.readAsText(file);
    });
  };

  // const handlePatchNameConfirm = async () => {
  //   const trimmedName = patchName.trim();
  //   if (!trimmedName) return;

  //   setPatchNameModalOpen(false);
  //   uploadZipToServer(trimmedName, patchVersion);
  // };

  // const uploadZipToServer = async (versionStr, currentPatchVersion) => {
  //   const hasMain = files.some(
  //     (f) => f.type === 'file' && f.name === 'main.py',
  //   );
  //   const hasRequirements = files.some(
  //     (f) => f.type === 'file' && f.name === 'requirements.txt',
  //   );
  //   // Check for version.txt existence and content
  //   const versionFile = files.find(
  //     (f) => f.type === 'file' && f.name === 'version.txt',
  //   );
  //   if (!hasMain || !hasRequirements) {
  //     toast({
  //       title: 'Missing Required Files',
  //       description:
  //         "Make sure 'main.py' and 'requirements.txt' exist before uploading.",
  //       status: 'warning',
  //       position: 'top',
  //       duration: 4000,
  //       isClosable: true,
  //     });
  //     return;
  //   }
  //   if (!versionFile || !versionFile.content || !versionFile.content.trim()) {
  //     toast({
  //       title: 'Missing Version',
  //       description: "The 'version.txt' file must not be empty.",
  //       status: 'error',
  //       position: 'top',
  //       duration: 4000,
  //       isClosable: true,
  //     });
  //     return;
  //   }
  //   // Validate version.txt format: must be v1, v2, etc.
  //   if (!/^v\d+$/i.test(versionFile.content.trim())) {
  //     toast({
  //       title: 'Invalid Version Format',
  //       description:
  //         "The 'version.txt' file must be in the format 'v1', 'v2', etc.",
  //       status: 'error',
  //       position: 'top',
  //       duration: 4000,
  //       isClosable: true,
  //     });
  //     return;
  //   }
  //   const patchVersion =
  //     currentPatchVersion === 0 ? 1 : currentPatchVersion + 1;

  //   const zip = new JSZip();
  //   const buildZipTree = (currentFolder, parent) => {
  //     const children = files.filter(
  //       (f) => f.parentId === (parent ? parent.id : null),
  //     );
  //     for (const item of children) {
  //       if (item.type === 'file') {
  //         currentFolder.file(item.name, item.content || '');
  //       } else if (item.type === 'folder') {
  //         const newFolder = currentFolder.folder(item.name);
  //         buildZipTree(newFolder, item);
  //       }
  //     }
  //   };
  //   buildZipTree(zip, null);

  //   try {
  //     const blob = await zip.generateAsync({ type: 'blob' });
  //     const arrayBuffer = await blob.arrayBuffer();
  //     const base64Data = btoa(
  //       new Uint8Array(arrayBuffer).reduce(
  //         (data, byte) => data + String.fromCharCode(byte),
  //         '',
  //       ),
  //     );

  //     const payload = {
  //       addPatchToDevice: 1,
  //       content: base64Data,
  //       version: patchVersion,
  //       patch_id: patchId,
  //       patch_name: patchName,
  //     };
  //     await axiosInstance.post(apiUrls.savePatch(deviceId), payload);

  //     toast({
  //       title: 'Upload Successful',
  //       description: 'Files zipped and uploaded successfully.',
  //       status: 'success',
  //       position: 'top',
  //       duration: 3000,
  //       isClosable: true,
  //     });

  //     // Fetch latest values after successful upload
  //     await fetchConfigurations();
  //     await fetchPatches();
  //   } catch (err) {
  //     console.error('Upload failed:', err);
  //     toast({
  //       title: 'Upload Failed',
  //       description: 'An error occurred while uploading the zip.',
  //       status: 'error',
  //       position: 'top',
  //       duration: 3000,
  //       isClosable: true,
  //     });
  //   }
  // };

  // Helper to decode base64 zip and return file structure
  const decodeBase64ZipToFiles = async (base64, generateId) => {
    const zip = new JSZip();
    const binaryStr = atob(base64);
    const byteArray = Uint8Array.from(binaryStr, (c) => c.charCodeAt(0));
    const unzipped = await zip.loadAsync(byteArray);

    const filesList = [];
    const folderMap = {};
    let rootFolderId = null;

    if (!unzipped.folder('Project/')) {
      rootFolderId = generateId();
      folderMap['Project'] = rootFolderId;
      filesList.push({
        id: rootFolderId,
        name: 'Project',
        type: 'folder',
        parentId: null,
      });
    }

    await Promise.all(
      Object.keys(unzipped.files).map(async (filePath) => {
        const zipEntry = unzipped.files[filePath];
        const segments = filePath.split('/').filter(Boolean);
        if (segments.length === 0) return;

        let currentPath = 'Project';
        let parentId = rootFolderId;

        for (let i = 0; i < segments.length - (zipEntry.dir ? 0 : 1); i++) {
          currentPath += `/${segments[i]}`;
          if (!folderMap[currentPath]) {
            const id = generateId();
            folderMap[currentPath] = id;
            filesList.push({
              id,
              name: segments[i],
              type: 'folder',
              parentId,
            });
          }
          parentId = folderMap[currentPath];
        }

        if (!zipEntry.dir) {
          const fileName = segments[segments.length - 1];
          const content = await zipEntry.async('text');
          filesList.push({
            id: generateId(),
            name: fileName,
            type: 'file',
            content,
            parentId,
          });
        }
      }),
    );

    const hasRootFolder = filesList.some(
      (f) => f.parentId === null && f.type === 'folder',
    );
    if (!hasRootFolder) {
      const projectId = generateId();
      filesList.forEach((f) => {
        if (f.parentId === null) f.parentId = projectId;
      });

      filesList.unshift({
        id: projectId,
        name: 'Project',
        type: 'folder',
        parentId: null,
      });
    }

    return filesList;
  };

  const themes = {
    'Light (vs-light)': 'vs-light',
    'Dark (vs-dark)': 'vs-dark',
    'High Contrast Dark': 'hc-black',
    'High Contrast Light': 'hc-light',
    'Solarized Light': 'solarized-light',
  };
  // Helper to build the patch payload (same as in save)

  // Handler for Apply to devices
  // Helper to build the patch payload (same as in save)
  const buildPatchPayload = async () => {
    if (!patchName.trim()) throw new Error('Patch name is required.');
    const hasMain = files.some(
      (f) => f.type === 'file' && f.name === 'main.py',
    );
    const hasRequirements = files.some(
      (f) => f.type === 'file' && f.name === 'requirements.txt',
    );
    const versionFile = files.find(
      (f) => f.type === 'file' && f.name === 'version.txt',
    );
    if (!hasMain || !hasRequirements) {
      throw new Error(
        "Make sure 'main.py' and 'requirements.txt' exist before uploading.",
      );
    }
    if (!versionFile || !versionFile.content || !versionFile.content.trim()) {
      throw new Error("The 'version.txt' file must not be empty.");
    }
    if (!/^v\d+$/i.test(versionFile.content.trim())) {
      throw new Error(
        "The 'version.txt' file must be in the format 'v1', 'v2', etc.",
      );
    }
    const versionMatch = patchName.match(/v?(\d+)/i);
    const patchVersion = versionMatch ? parseInt(versionMatch[1], 10) : 1;

    const zip = new JSZip();
    const buildZipTree = (currentFolder, parent) => {
      const children = files.filter(
        (f) => f.parentId === (parent ? parent.id : null),
      );
      for (const item of children) {
        if (item.type === 'file') {
          currentFolder.file(item.name, item.content || '');
        } else if (item.type === 'folder') {
          const newFolder = currentFolder.folder(item.name);
          buildZipTree(newFolder, item);
        }
      }
    };
    buildZipTree(zip, null);

    const blob = await zip.generateAsync({ type: 'blob' });
    const arrayBuffer = await blob.arrayBuffer();
    const base64Data = btoa(
      new Uint8Array(arrayBuffer).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        '',
      ),
    );

    return {
      apply_to_devices: 1,
      content: base64Data,
      version: patchVersion,
      patch_id: patchId,
      patch_name: patchName,
    };
  };

  const handleApplyToDevices = async () => {
    try {
      const payload = await buildPatchPayload();

      await axiosInstance.post(
        apiUrls.updatePatch(PLATFORM_ID, groupId),
        payload,
      );

      toast({
        title: 'Patch Applied',
        description: 'Patch configuration applied to devices successfully.',
        status: 'success',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
    } catch (err) {
      toast({
        title: 'Error',
        description: err.message || 'Failed to apply patch payload.',
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
    }
  };
  const handleSaveLogicToDevices2 = async () => {
    if (!patchName.trim()) return;
    const hasMain = files.some(
      (f) => f.type === 'file' && f.name === 'main.py',
    );
    const hasRequirements = files.some(
      (f) => f.type === 'file' && f.name === 'requirements.txt',
    );
    const versionFile = files.find(
      (f) => f.type === 'file' && f.name === 'version.txt',
    );
    if (!hasMain || !hasRequirements) {
      toast({
        title: 'Missing Required Files',
        description:
          "Make sure 'main.py' and 'requirements.txt' exist before uploading.",
        status: 'warning',
        position: 'top',
        duration: 4000,
        isClosable: true,
      });
      return;
    }
    if (!versionFile || !versionFile.content || !versionFile.content.trim()) {
      toast({
        title: 'Missing Version',
        description: "The 'version.txt' file must not be empty.",
        status: 'error',
        position: 'top',
        duration: 4000,
        isClosable: true,
      });
      return;
    }
    if (!/^v\d+$/i.test(versionFile.content.trim())) {
      toast({
        title: 'Invalid Version Format',
        description:
          "The 'version.txt' file must be in the format 'v1', 'v2', etc.",
        status: 'error',
        position: 'top',
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    const versionMatch = patchName.match(/v?(\d+)/i);
    const patchVersion = versionMatch ? parseInt(versionMatch[1], 10) : 1;

    const zip = new JSZip();
    const buildZipTree = (currentFolder, parent) => {
      const children = files.filter(
        (f) => f.parentId === (parent ? parent.id : null),
      );
      for (const item of children) {
        if (item.type === 'file') {
          currentFolder.file(item.name, item.content || '');
        } else if (item.type === 'folder') {
          const newFolder = currentFolder.folder(item.name);
          buildZipTree(newFolder, item);
        }
      }
    };
    buildZipTree(zip, null);
    try {
      const blob = await zip.generateAsync({ type: 'blob' });
      const arrayBuffer = await blob.arrayBuffer();
      const base64Data = btoa(
        new Uint8Array(arrayBuffer).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          '',
        ),
      );

      const checkedDeviceIds = devicesArray
        .filter((d) => selectedDevices.includes(d.id))
        .map((d) => d.name);

      let allDeviceIds = checkedDeviceIds;

      allDeviceIds = Array.from(new Set(allDeviceIds.filter(Boolean)));
      for (const deviceName of allDeviceIds) {
        const payload = {
          addPatchToDevice: 1,
          content: base64Data,
          version: patchVersion,
          patch_id: patchId,
          patch_name: patchName,
        };
        await axiosInstance.post(apiUrls.savePatch(deviceName), payload);
      }

      toast({
        title: 'Upload Successful',
        description: 'Files zipped and uploaded successfully.',
        status: 'success',
        position: 'top',
        duration: 3000,
        isClosable: true,
      });
      fetchConfigurations();

      setIsSaveLogicModalOpen(false);
      navigate('/patches');
      onCloseSaveConf();
    } catch (err) {
      console.error('Upload failed:', err);
      toast({
        title: 'Upload Failed',
        description: 'An error occurred while uploading the zip.',
        status: 'error',
        position: 'top',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const onOpenSaveConf = () => {
    const navDevices = location.state?.devices || [];

    let devicesToPreselect = [];

    if (navDevices.length > 0) {
      devicesToPreselect =
        typeof navDevices[0] === 'object'
          ? navDevices.map((d) => d.device_id || d.id)
          : navDevices;
    }

    const allPreselected =
      devicesToPreselect.length > 0 ? devicesToPreselect : [];

    setSelectedDevices(allPreselected);
    setSearchType('deviceId');
    setSelectedCluster('');
    setStateOptions([]);
    setSelectedState('');
    setNocOptions([]);
    setSelectedNoc('');
    setPlantOptions([]);
    setSelectedPlant('');
    setDevicesArray([]);
    setSerialNumber('');
    setCurrentPage(-1);

    setPreselectedDeviceIds(allPreselected);

    DeviceSaveConf();
    fetchAllDevices('', true, 0);
  };
  const handleCheckboxChange = (id) => {
    setSelectedDevices((prev) =>
      prev.includes(id) ? prev.filter((d) => d !== id) : [...prev, id],
    );
  };

  const fetchCountries = async () => {
    try {
      const resp = await axiosInstance.get(apiUrls.getCountries());
      const options = (resp.data?.data || []).map((item) => ({
        label: item.name,
        value: item.id.id,
      }));
      setClusterOptions(options);
    } catch {
      setClusterOptions([]);
    }
  };

  const fetchStates = async (countryId) => {
    try {
      const resp = await axiosInstance.get(apiUrls.getChildren(countryId));
      const options = (resp.data || []).map((item) => ({
        label: item.toName,
        value: item.to.id,
      }));
      setStateOptions(options);
    } catch {
      setStateOptions([]);
    }
  };

  const fetchNocs = async (stateId) => {
    try {
      const resp = await axiosInstance.get(apiUrls.getChildren(stateId));
      const options = (resp.data || []).map((item) => ({
        label: item.toName,
        value: item.to.id,
      }));
      setNocOptions(options);
    } catch {
      setNocOptions([]);
    }
  };

  const fetchPlants = async (nocId) => {
    try {
      const resp = await axiosInstance.get(apiUrls.getChildren(nocId));
      const options = (resp.data || []).map((item) => ({
        label: item.toName,
        value: item.to.id,
      }));
      setPlantOptions(options);
    } catch {
      setPlantOptions([]);
    }
  };

  const fetchClusterDevices = async (id) => {
    setLoadingDevices(true);
    try {
      const token = Cookies.get('authToken');
      const resp = await fetch(apiUrls.getClusterDevices(id), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });
      if (!resp.ok) throw new Error('Network response was not ok');
      const data = await resp.json();

      const devicesNameIdMap = (data?.devices || []).map((d) => ({
        id: String(d.id),
        name: d.name,
      }));
      setDevicesArray(devicesNameIdMap);

      // IMPORTANT: Only preselect devices from navigation, NOT from preselectedDevices
      const navDevices = location.state?.devices || [];
      const devicesToPreselect = navDevices.map(
        (device) => device.device_id || device.id,
      );

      // Filter devices that exist in the current devicesArray and are in navigation
      const preselected = devicesNameIdMap
        .filter(
          (d) =>
            devicesToPreselect.includes(d.id) ||
            devicesToPreselect.includes(d.name),
        )
        .map((d) => d.id);

      // Don't automatically include deviceId - only include navigation devices
      setSelectedDevices(preselected);
    } catch (err) {
      setDevicesArray([]);
      setSelectedDevices([]);
      console.error('Failed to fetch cluster devices:', err);
    } finally {
      setLoadingDevices(false);
    }
  };
  useEffect(() => {
    if (selectedCluster) {
      fetchStates(selectedCluster);
      setSelectedState('');
      setNocOptions([]);
      setSelectedNoc('');
      setPlantOptions([]);
      setSelectedPlant('');
      setDevicesArray([]);
      fetchClusterDevices(selectedCluster);
    }
  }, [selectedCluster]);

  useEffect(() => {
    if (selectedState) {
      fetchNocs(selectedState);
      setSelectedNoc('');
      setPlantOptions([]);
      setSelectedPlant('');
      setDevicesArray([]);
      fetchClusterDevices(selectedState);
    }
  }, [selectedState]);

  useEffect(() => {
    if (selectedNoc) {
      fetchPlants(selectedNoc);
      setSelectedPlant('');
      setDevicesArray([]);
      fetchClusterDevices(selectedNoc);
    }
  }, [selectedNoc]);

  useEffect(() => {
    if (selectedPlant) {
      setLoadingDevices(true);
      fetchClusterDevices(selectedPlant);
    }
  }, [selectedPlant]);

  useEffect(() => {
    if (searchType === 'cluster') {
      fetchCountries();
      setSelectedDevices(
        preselectedDevices.length > 0
          ? Array.from(new Set([...preselectedDevices, deviceId]))
          : [deviceId],
      );
      setSelectedCluster('');
      setStateOptions([]);
      setSelectedState('');
      setNocOptions([]);
      setSelectedNoc('');
      setPlantOptions([]);
      setSelectedPlant('');
      setDevicesArray([]);
      setSerialNumber('');
      setCurrentPage(-1);
    }
  }, [searchType]);

  useEffect(() => {
    if (searchType === 'deviceId') {
      setSelectedDevices(
        Array.from(new Set([...preselectedDevices, deviceId])),
      );
    }
  }, [searchType, preselectedDevices]);
  useEffect(() => {
    if (searchType === 'deviceId') {
      setDevicesArray([]);
      setCurrentPage(0);
      fetchAllDevices(serialNumber, true, 0);
    }
  }, [searchType]);

  return (
    <>
      <Flex
        direction="column"
        h="auto"
        align="flex-start"
        color={optionText}
        fontSize="lg"
        gap={2}
        mb={4}
        mt={6}
        ml={1}
      >
        <BreadCrumb items={breadcrumbItems} sidebarWidth={sidebarWidth} />

        <Heading size="lg" mb={2} ml={sidebarWidth}>
          {patchName ? patchName : 'No Patch Selected'}
        </Heading>
      </Flex>
      <Flex direction="column" h="100vh">
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
        <Flex flex="1" overflow="hidden">
          {/* File Explorer Panel */}

          <Card
            ml={sidebarWidth}
            minW="250px"
            maxW="25%"
            width={`calc(100% - ${sidebarWidth})`}
            bg={panelBg}
            p={4}
            overflowY="auto"
            me={3}
            flexShrink={0}
          >
            {loading ? (
              <>
                <Skeleton height="40px" mb={4} />
                <SkeletonText noOfLines={10} spacing="4" />
              </>
            ) : (
              <>
                <Flex gap={2} mb={4}>
                  {isTenantAdmin && (
                    <Button
                      colorScheme="green"
                      variant="outline"
                      border="2px"
                      cursor="pointer"
                      ml={1}
                      onClick={() => {
                        onOpenSaveConf();
                        setCurrentPage(0);
                        setDevicesArray([]);
                        setSearchType('deviceId');
                      }}
                    >
                      Publish
                    </Button>
                  )}

                  {isTenantAdmin && status !== 'published' && (
                    <Button
                      colorScheme="blue"
                      variant="outline"
                      onClick={() => {
                        setIsSaveLogicModalOpen(true);

                        const selectedPatch = patchOptions.find(
                          (opt) => opt.value === patchId,
                        );
                        setPatchName(selectedPatch?.label || '');
                      }}
                      mb={4}
                    >
                      Save as Draft
                    </Button>
                  )}
                </Flex>

                <FileExplorer
                  files={files}
                  selectedFile={selectedFile}
                  onFileSelect={(f) => {
                    setSelectedFile(f);
                    setPythonCode(f.content || '');
                  }}
                  onRenameItem={openRename}
                  onDeleteItem={openDelete}
                  onCreateFile={openCreateFile}
                  onCreateFolder={openCreateFolder}
                  onImportFile={handleImportFile}
                  onImportFolder={handleFolderImport}
                />
              </>
            )}
          </Card>

          {/* Editor Panel */}
          <Box
            flex="1"
            pt={6}
            h="100%"
            bg={panelBg}
            borderRadius="md"
            overflow="hidden"
          >
            {loading ? (
              <Skeleton height="100%" />
            ) : selectedFile && selectedFile.type === 'file' ? (
              <>
                <Box mb={4}>
                  <Flex
                    h="auto"
                    align="center"
                    justify="space-around"
                    color={optionText}
                    fontSize="lg"
                    px={4}
                    pb={2}
                  >
                    <FormControl w="200px">
                      <FormLabel fontSize="sm">Editor Theme</FormLabel>
                      <InterfaceSelect
                        value={editorTheme}
                        onChange={(val) => setEditorTheme(val)}
                        options={themes}
                      />
                    </FormControl>
                  </Flex>
                </Box>
                <Editor
                  language="python"
                  theme={editorTheme}
                  value={pythonCode}
                  onChange={(value) => {
                    setPythonCode(value);
                    setFiles((prev) =>
                      prev.map((f) =>
                        f.id === selectedFile.id ? { ...f, content: value } : f,
                      ),
                    );
                  }}
                  options={{
                    fontSize: 14,
                    minimap: { enabled: false },
                    automaticLayout: true,
                  }}
                  height="100%"
                />
              </>
            ) : (
              <Flex
                h="100%"
                align="center"
                justify="center"
                color={optionText}
                fontSize="lg"
              >
                Select a file to edit
              </Flex>
            )}
          </Box>
        </Flex>

        <NameModal
          isOpen={renameState.isOpen}
          onClose={closeRename}
          title={`Rename ${renameState.item?.type}`}
          placeholder="Enter new name"
          value={renameState.newName}
          onChange={(e) =>
            setRenameState((s) => ({ ...s, newName: e.target.value }))
          }
          onConfirm={handleRenameConfirm}
          isConfirmDisabled={!renameState.newName.trim()}
        />

        {/* Delete Confirmation */}
        <GlobalAlertDialog
          isOpen={deleteState.isOpen}
          onClose={closeDelete}
          onConfirm={handleDeleteConfirm}
          title={`Delete ${deleteState.item?.type}`}
          body={
            <>
              Are you sure you want to delete <b>{deleteState.item?.name}</b>?
              This action cannot be undone.
            </>
          }
          confirmText="Delete"
          cancelText="Cancel"
          showCancel={true}
        />

        {/* Create file handlers */}
        <NameModal
          isOpen={createFileState.isOpen}
          onClose={closeCreateFile}
          title="Create New File"
          placeholder="File name"
          value={createFileState.fileName}
          onChange={(e) =>
            setCreateFileState((s) => ({ ...s, fileName: e.target.value }))
          }
          onConfirm={handleCreateFileConfirm}
          isConfirmDisabled={!createFileState.fileName.trim()}
        />

        {/* Create Folder Modal */}
        <NameModal
          isOpen={createFolderState.isOpen}
          onClose={closeCreateFolder}
          title="Create New Folder"
          placeholder="Folder name"
          value={createFolderState.folderName}
          onChange={(e) =>
            setCreateFolderState((s) => ({ ...s, folderName: e.target.value }))
          }
          onConfirm={handleCreateFolderConfirm}
          isConfirmDisabled={!createFolderState.folderName.trim()}
        />

        <NameModal
          isOpen={patchNameModalOpen}
          onClose={() => setPatchNameModalOpen(false)}
          title="Patch Name"
          placeholder="Enter patch name..."
          value={patchName}
          onChange={(e) => setPatchName(e.target.value)}
          // onConfirm={handlePatchNameConfirm}
          isConfirmDisabled={!patchName.trim()}
        />
      </Flex>
      <NameModal
        isOpen={isSaveLogicModalOpen}
        onClose={() => setIsSaveLogicModalOpen(false)}
        title="Patch Name"
        placeholder="Enter patch name..."
        value={patchName}
        onChange={(e) => setPatchName(e.target.value)}
        onConfirm={handleSaveLogicToDevices}
        isConfirmDisabled={!patchName.trim()}
        confirmLabel="Save as Draft"
      />
      <GlobalAlertDialog
        isOpen={isApplyConfirmOpen}
        onClose={() => setIsApplyConfirmOpen(false)}
        onConfirm={async () => {
          setIsApplyConfirmOpen(false);
          await handleApplyToDevices();
        }}
        title="Apply Patch to Devices"
        body="Are you sure you want to save and apply this patch? "
        confirmText="Yes, Apply"
        cancelText="Cancel"
        showCancel={true}
      />
      <ClusterModal
        isOpen={isOpenSaveConf}
        onClose={() => {
          onCloseSaveConf();
          setCurrentPage(-1);
        }}
        title={`Save Patch`}
        mainInputLabel="Patch Name"
        mainInputValue={patchName}
        onMainInputChange={(e) => setPatchName(e.target.value)}
        searchType={searchType}
        onSearchTypeChange={setSearchType}
        serialNumber={serialNumber}
        onSerialNumberChange={(e) => setSerialNumber(e.target.value)}
        onSerialNumberSearch={async (e) => {
          if (e.key === 'Enter') {
            fetchAllDevices(e.target.value, true, 0);
          }
        }}
        clusterOptions={clusterOptions}
        selectedCluster={selectedCluster}
        onClusterChange={setSelectedCluster}
        stateOptions={stateOptions}
        selectedState={selectedState}
        onStateChange={setSelectedState}
        nocOptions={nocOptions}
        selectedNoc={selectedNoc}
        onNocChange={setSelectedNoc}
        plantOptions={plantOptions}
        selectedPlant={selectedPlant}
        onPlantChange={setSelectedPlant}
        devicesArray={devicesArray}
        selectedDevices={selectedDevices}
        onDeviceToggle={handleCheckboxChange}
        onSelectAllDevices={(e) => {
          if (e.target.checked) {
            setSelectedDevices(devicesArray.map((d) => d.id));
          } else {
            setSelectedDevices([]);
          }
        }}
        loadingDevices={loadingDevices}
        onLoadMore={() => setCurrentPage((prev) => prev + 1)}
        onSave={handleSaveLogicToDevices2}
        saveDisabled={!patchName}
        inputBg={inputBg}
        textColor={textColor}
        footerError={!patchName}
        footerErrorText="Patch name is required."
        deviceId={deviceId}
        showMainInputDisabled={true}
        disablePreselectedDevices={true}
        disableCurrentDevice={false}
        preselectedDevices={
          preselectedDeviceIds.length > 0
            ? preselectedDeviceIds
            : location.state?.devices?.map((d) => d.device_id || d.id) || []
        }
      />
      <Flex
        as="footer"
        position="fixed"
        left={0}
        bottom="0"
        width="100%"
        bg={useColorModeValue('gray.100', 'navy.800')}
        color={useColorModeValue('gray.600', 'gray.200')}
        py={2}
        px={4}
        align="center"
        justify="space-between"
        zIndex={20} // higher than sidebar
        borderTop="1px solid"
        borderColor={useColorModeValue('gray.200', 'gray.700')}
        boxShadow="0 -2px 8px rgba(0,0,0,0.04)"
      >
        <Text fontSize="sm" fontWeight="medium">
          Version 1.0.0
        </Text>
        <Text fontSize="sm" fontWeight="medium">
          UGX Systems
        </Text>
      </Flex>
    </>
  );
};

export default PatchConfigurations;
